import { ChartLineIcon } from 'lucide-react';

export const ExplorerIcon = ChartLineIcon;
